import { api } from '@/main'
import router from '@/router'
import cookies from 'js-cookie'

const defaultState = {
  access_token: '',
  created_at: '',
  expires_in: '',
  token_type: ''
}

const clearLocalStorage = () => {
  ;[
    'authRemember',
    'authToken',
    'authTokenCreatedAt',
    'authTokenExpiresIn',
    'authTokenType'
  ].forEach(item => localStorage.removeItem(item))
}

export default {
  namespaced: true,
  state: {
    ...defaultState
  },
  mutations: {
    SET_AUTH: (state, auth) => (state = Object.assign(state, auth))
  },
  actions: {
    async restoreSession(store) {
      if (
        localStorage.getItem('authToken') &&
        localStorage.getItem('authRemember') === 'true'
      ) {
        try {
          // TODO: check token expiration before restoring the user so it doesn't throw an error anyway
          // Try to restore the session
          store.commit('SET_AUTH', {
            access_token: localStorage.getItem('authToken'),
            created_at: localStorage.getItem('authTokenCreatedAt'),
            expires_in: localStorage.getItem('authTokenExpiresIn'),
            token_type: localStorage.getItem('authTokenType')
          })

          await store.dispatch('customer/getCustomer', null, {
            root: true
          })

          document.body.classList.add('logged')
        } catch (error) {
          // If error while restoring; just remove everything from the localStorage
          clearLocalStorage()

          router.push({
            name: 'login'
          })

          document.body.classList.remove('logged')
        }
      } else if (cookies.getJSON('arpejAuth')) {
        try {
          store.commit('SET_AUTH', cookies.getJSON('arpejAuth'))

          await store.dispatch('customer/getCustomer', null, {
            root: true
          })

          document.body.classList.add('logged')
        } catch (error) {
          cookies.remove('arpejAuth')
          document.body.classList.remove('logged')
        }
      } else {
        clearLocalStorage()
      }
    },
    /**
     * Login the user.
     *
     * @param {*} data { email, password }
     */
    async login(store, data) {
      const r = await api.auth.getToken({
        grant_type: 'password',
        username: data.email,
        password: data.password
      })

      store.commit('SET_AUTH', r)

      localStorage.setItem('authToken', r.access_token)

      if (data.remember) {
        localStorage.setItem('authRemember', data.remember)
        localStorage.setItem('authTokenCreatedAt', r.created_at)
        localStorage.setItem('authTokenExpiresIn', r.expires_in)
        localStorage.setItem('authTokenType', r.token_type)
      } else {
        cookies.set(
          'arpejAuth',
          {
            access_token: r.access_token,
            created_at: r.created_at,
            expires_in: r.expires_in,
            token_type: r.token_type
          },
          { expires: 1 }
        )
      }

      await store.dispatch('customer/getCustomer', null, { root: true })

      if (
        store.rootState.residences.selectedResidence &&
        store.rootState.residences.selectedAvailability
      ) {
        store.dispatch(
          'records/createRecord',
          {
            residence: store.rootState.residences.selectedResidence,
            availability: store.rootState.residences.selectedAvailability
          },
          { root: true }
        )
      }

      // grid
      router.push({ name: 'records-grid' })

      document.body.classList.add('logged')
    },
    /**
     * Logout the user.
     */
    async logout(store) {
      await api.auth.revokeToken()
      clearLocalStorage()
      store.commit('SET_AUTH', defaultState)

      // Reset submodules
      store.dispatch('residences/resetModule', null, { root: true })
      store.dispatch('customer/resetModule', null, { root: true })
      store.dispatch('records/resetModule', null, { root: true })
      store.dispatch('recordsPeople/resetModule', null, { root: true })
      store.dispatch('recordsDocuments/resetModule', null, { root: true })

      router.push({ name: 'login' })

      // remove cookie
      cookies.remove('arpejAuth')

      document.body.classList.remove('logged')
    },
    async setAuthFromToken(store, data) {
      store.commit('SET_AUTH', data.token)

      localStorage.setItem('authToken', data.token.access_token)

      cookies.set(
        'arpejAuth',
        {
          access_token: data.token.access_token,
          created_at: data.token.created_at,
          expires_in: data.token.expires_in,
          token_type: data.token.token_type
        },
        { expires: 1 }
      )

      // grid
      router.push({
        name: 'records-grid'
      })
    }
  },
  getters: {
    token: state => state.access_token,
    logged_in: state =>
      state.access_token && state.access_token !== '' ? true : false
  }
}
